export default __webpack_public_path__ + "static/media/gs-5.d81e06af.png";